// import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
// import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { BookingHistoryTableDataColumnType, BookingHistoryTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const bookingHistoryTableData = [
    {
        ticketBookingId: 6,
        ticketNumber: "SWP-4893",
        emailId: "RadheShyam92@gmail.com",
        ticketUniqueId: "REF-SWP-4893",
        bookingDate: "2025-05-15T18:02:32.2588901",
        customerName: "RadheShyam Kumar",
        customerMobileNumber: "2345678910",
        address: "Kokar, Ranchi",
        numberOdAdults: "5",
        numberOfChildren: "2",
        createdDate: "2025-05-15T18:02:32.3774301",
        applicationUserId: "e3a396c3-e56c-45b7-996d-a449c24c907d"
    },
    {
        ticketBookingId: 7,
        ticketNumber: "SWP-4895",
        emailId: "RadheShyam892@gmail.com",
        ticketUniqueId: "REF-SWP-4895",
        bookingDate: "2025-05-15T18:02:32.2588901",
        customerName: "RadheShyam Kumar",
        customerMobileNumber: "2345678910",
        address: "Kokar, Ranchi",
        numberOdAdults: "5",
        numberOfChildren: "2",
        createdDate: "2025-05-15T18:02:32.3774301",
        applicationUserId: "e3a396c3-e56c-45b7-996d-a449c24c907d"
    },
];

// const ProductListTableAction = ({adultPlanId}) => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <button className="btn btn-sm">
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//       </button>
//       <p>{adultPlanId}</p>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
  // Your delete logic here (API call, state update, etc.)
  // console.log("Deleting ID:", id);
  try {
    await api.put(`/api/TicketBooking/TicketBookingCancel?ticketBookingId=${id}`);
    Swal.fire('Cancel!', ' Ticket Booking has been cancelled successful.', 'success');

    // Optional: refresh the list
    // setBookingHistoryTableDatas((prev) => prev.filter((item: { adultPlanId: any; }) => item.adultPlanId !== id));
  } catch (error) {
    Swal.fire('Error!', 'Failed to delete the ticket booking cancelled.', 'error');
    console.error("Cancel error:", error);
  }
};

interface ProductListTableActionProps {
    ticketBookingId: any;
  onDelete: (id: number) => void;
}

export const BookingHistoryTableAction: React.FC<ProductListTableActionProps> = ({ ticketBookingId, onDelete }) => {

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this ticket booking record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Cancelled it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(ticketBookingId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <button className="btn btn-sm" onClick={handleDeleteClick} title="Cancelled">
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};

export const BookingHistoryTableProductName: React.FC<BookingHistoryTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const BookingHistoryTableStatus :React.FC<BookingHistoryTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export const bookingHistoryTableDataColumn: TableColumn<BookingHistoryTableDataColumnType>[] = [
  {
    name: "Ticket Number",
    cell: (row) => <BookingHistoryTableProductName title={row.ticketNumber}/>,
    sortable: true,
    grow: 2,
  },
  {
    name: "Ticket ID",
    selector: (row) => `${row.ticketUniqueId}`,
    sortable: true,
  },
  {
    name: "Customer Name",
    selector: (row) => `${row.customerName}`,
    sortable: true,
  },
  {
    name: "Customer Mobile No.",
    cell: (row) =>  <BookingHistoryTableStatus title={row.customerMobileNumber} />,
  },
  {
    name: "No. Of Adults",
    cell: (row) =>  <BookingHistoryTableStatus title={row.numberOdAdults} />,
  },
  {
    name: "No. Of Child",
    cell: (row) =>  <BookingHistoryTableStatus title={row.numberOfChildren} />,
  },
  {
    name: "Booking Date",
    cell: (row) =>  <BookingHistoryTableStatus title={row.bookingDate} />,
  },
  {
    name: "Address",
    cell: (row) =>  <BookingHistoryTableStatus title={row.address} />,
  },
  {
    name: "Created Date",
    cell: (row) =>  <BookingHistoryTableStatus title={row.createdDate} />,
  },
  {
    name: "Action",
    cell: (row) => <BookingHistoryTableAction ticketBookingId={row.ticketBookingId} onDelete={handleDelete} />,
  },
];

  export const filtersData = [
    {
      name: "Choose Ticket No.",
      options: ["SWP-4893", "SWP-2311"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
    {
      name: "customerMobileNumber",
      options: ["8347821920"],
    },
  ];